import * as Headless from '@sail/theme-headless';
import {css, theme} from '../theme';

export const focus = theme(Headless.focus, [
  css({
    '&:focus': {
      focusRing: 'focus',
      outline: css.value('none'),
    },
  }),
]);

export const focusSibling = theme(Headless.focusSibling, [
  css({
    '&:focus + div': {
      focusRing: 'focus',
    },
  }),
]);

export const focusWithin = theme(Headless.focusWithin, [
  /* TODO: kill focus-within - safari doesnt support it */
  css({
    '&:focus-within': {
      keyline: 'neutral',
      focusRing: 'focus',
    },
  }),
]);
